<template>
  <div class="container-grid grid-3 grid-md-1 mb-24">
    <div class="container-grid__item" v-for="(doc, index) in documents" :key="index">
      <ContentDocumentCard :title="doc.title" :link="doc.link" />
    </div>
  </div>
</template>

<script>
import ContentDocumentCard from './ContentDocumentCard.vue'

export default {
  name: 'ContentDocumentGrid',
  components: { ContentDocumentCard },
  props: {
    documents: {
      type: Array,
      required: true // [{ title: '', link: '' }]
    }
  }
}
</script>
